import React from 'react';

export default function Stop({ size, color }) {
  return (
    <svg width={size} height={size} fill={color} viewBox='0 0 24 24'>
      <path d='M18,18H6V6H18V18Z' />
    </svg>
  );
}
